class MobileMenu extends HTMLElement {
  constructor() {
    super();
    // We'll initialize properties in connectedCallback
  }

  connectedCallback() {
    // Initialize properties and set up event listeners
    this.hamburgerButton = this.querySelector('.hamburger');
    this.mobileMenu = this.querySelector('.mobile-menu');
    this.header = this.querySelector('header');
    // this.closeMenu = this.querySelector('.close-menu');

    console.log(this.hamburgerButton);
    this.hamburgerButton.addEventListener('click', () => this.toggleMenu());
    // this.closeMenu.addEventListener('click', () => this.toggleMenu());
  }

  toggleMenu() {
    this.hamburgerButton.classList.toggle('active');
    this.mobileMenu.classList.toggle('tw-opacity-0');
    this.mobileMenu.classList.toggle('active');
    this.mobileMenu.querySelector('.inner').style.paddingTop = `${this.header.offsetHeight}px`;

    // Toggle body scroll
    if (this.mobileMenu.classList.contains('active')) {
      document.body.style.overflow = 'hidden';
      document.querySelector('html').style.overflow = 'hidden';
      this.header.classList.add('scrolled');
    } else {
      document.body.style.overflow = '';
      document.querySelector('html').style.overflow = '';
    }
  }

  disconnectedCallback() {
    // Remove event listeners
    this.hamburgerButton.removeEventListener('click', () => this.toggleMenu());
  }

  // Add your custom methods here
}

customElements.define('mobile-menu', MobileMenu);

class MobileDropdown extends HTMLElement {
  constructor() {
    super();
    this.trigger = this.querySelector('[data-mobile-dropdown-trigger]');
    this.content = this.querySelector('[data-mobile-dropdown-content]');
    this.isOpen = false;
  }

  connectedCallback() {
    this.trigger.addEventListener('click', () => this.toggle());

    // Set initial height to 0
    this.content.style.height = '0px';
    this.content.style.overflow = 'hidden';
  }

  toggle() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    const contentHeight = this.content.scrollHeight;
    this.content.style.height = `${contentHeight}px`;
    this.trigger.classList.add('is-open');
    this.isOpen = true;

    // Rotate chevron
    const chevron = this.trigger.querySelector('[data-chevron]');
    if (chevron) {
      chevron.style.transform = 'rotate(180deg)';
    }
  }

  close() {
    this.content.style.height = '0px';
    this.trigger.classList.remove('is-open');
    this.isOpen = false;

    // Reset chevron
    const chevron = this.trigger.querySelector('[data-chevron]');
    if (chevron) {
      chevron.style.transform = 'rotate(0deg)';
    }
  }
}

customElements.define('mobile-dropdown', MobileDropdown);
